// @ts-check
import {
  initSchema
} from '@aws-amplify/datastore';
import {
  schema
} from './schema';

const FlyerStatus = {
  "TO_BE_CREATED": "TO_BE_CREATED",
  "CREATED": "CREATED",
  "TO_BE_UPDATED": "TO_BE_UPDATED",
  "UPDATED": "UPDATED",
  "TO_BE_DELETED": "TO_BE_DELETED",
  "DELETED": "DELETED"
};

const {
  Flyer
} = initSchema(schema);

export {
  Flyer,
  FlyerStatus
};
